import { render, staticRenderFns } from "./left-col.vue?vue&type=template&id=aa53c662&"
import script from "./left-col.vue?vue&type=script&lang=js&"
export * from "./left-col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports